import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/API";

export interface PaperCutOffDateItem {
  PAPER_CUT_OFF_DATE: string;
}

interface OptionType {
  value: string;
  label: string;
}
interface PaperCutOffDateState {
  data: PaperCutOffDateItem[];
  status: string;
  statusCode: number;
  error: string | null;
  isLoading: boolean;
  selectedPaperCutOffDate?: string[];
  selectedPaperCutOffDateList?: OptionType[];
}
const initialState: PaperCutOffDateState = {
  data: [],
  status: "",
  error: null,
  statusCode: 0,
  isLoading: false,
  selectedPaperCutOffDate: [],
  selectedPaperCutOffDateList: [],
};

export const fetchPaperCutOffDates = createAsyncThunk(
  "fetchPaperCutOffDates",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.post(API.FETCHPAPERCUTOFFDATES, data);
      return response;
    } catch (err: any) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue("error occurred");
    }
  }
);

const PaperCutOffDateSlice = createSlice({
  name: "PaperCutOffDateData",
  initialState,
  reducers: {
    UpdateSelectedPaperCutOffDate: (state, action) => {
      state.selectedPaperCutOffDate = action.payload;
    },
    UpdateSelectedPaperCutOffDateList: (state, action) => {
      state.selectedPaperCutOffDateList = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchPaperCutOffDates.pending, (state) => {
        state.isLoading = true;
        state.status = "Loading";
      })
      .addCase(fetchPaperCutOffDates.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = "success";
        state.data = action.payload.data;
      })
      .addCase(fetchPaperCutOffDates.rejected, (state) => {
        state.isLoading = false;
        state.status = "Failed";
        state.error = "Error";
      });
  },
});
export const {
  UpdateSelectedPaperCutOffDate,
  UpdateSelectedPaperCutOffDateList,
} = PaperCutOffDateSlice.actions;
export default PaperCutOffDateSlice.reducer;
